import { render } from "./Scores.vue?vue&type=template&id=0b8aadd4"
import script from "./Scores.vue?vue&type=script&lang=js"
export * from "./Scores.vue?vue&type=script&lang=js"
script.render = render

export default script